import {
  Component,
  Input,
  EventEmitter,
  Output,
} from "@angular/core";
import { CommonModule } from "@angular/common";

import { PrimeNGSharedModule } from "../../../../../shared/prime/prime-ng.module";
import {
  FormGroup,
  FormBuilder,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { ManageAssessmentApiService } from "../../../../../core/services/api/manage-assessment-api.service";
@Component({
  selector: "app-assessment-mail-popup",
  standalone: true,
  imports: [
    CommonModule,
    PrimeNGSharedModule,
    ReactiveFormsModule,
    
  ],
  templateUrl: "./assessment-mail-popup.component.html",
  styleUrl: "./assessment-mail-popup.component.scss",
})
export class AssessmentMailPopupComponent {
  @Input() visible: boolean = false;
  @Input() data: any;
  @Output() closeDialog = new EventEmitter<void>();
  @Output() emailSent = new EventEmitter<any>();
  isEdit: boolean = false;
  emailForm!: FormGroup;
  
  // Store default values for comparison
  private readonly defaultSubject = "Friendly Reminder: Design Change Assessment Submission Due Soon";
  private readonly defaultBody = `I hope you're doing well.\nThis is a gentle reminder to complete and submit your response to the Design Change Assessment. You can access the RIA platform and submit your response using the link below: [Platform Link] Please note that your due date [DDMMYYYY] is approaching. You have [2 days – 1 Day] remaining to submit your response. If no response is received by the due date, it will be considered as 'No Impact'.\nIf you have any questions regarding the Design Change Assessment, please don't hesitate to reach out.`;


  constructor(
    private readonly fb: FormBuilder,
    private readonly manageAssessmentApiService: ManageAssessmentApiService
  ) {
    this.initializeForm();
  }

  initializeForm() {
    this.emailForm = this.fb.group({
      custom_subject: [this.defaultSubject, [Validators.required]],
      custom_body: [this.defaultBody, [Validators.required]],
    });
  }

  close(): void {
    this.visible = false;
    this.isEdit = false; // Reset edit mode when closing
    this.emailForm.patchValue({
      custom_subject: this.defaultSubject,
      custom_body: this.defaultBody
    }); // Reset form to defaults
    this.closeDialog.emit();
  }

  postEmail(): void {
    const emailData = this.emailForm.value;
    
    // Check if the user has actually modified the content from defaults
    const isContentModified = 
      emailData.custom_subject !== this.defaultSubject || 
      emailData.custom_body !== this.defaultBody;
    
    let payload;
    if (isContentModified) {
      // User has modified the content, send custom email
      payload = {
        use_template: false,
        custom_subject: emailData.custom_subject,
        custom_body: emailData.custom_body.replaceAll('\n', '<br>'),
      };
    } else {
      // User hasn't modified content (or clicked Send without editing), use template
      payload = {
        use_template: true,
        custom_subject: null,
        custom_body: null,
      };
    }
    
    this.manageAssessmentApiService
      .postReminderEmail(this.data.response_mapping_id, payload)
      .subscribe({
        next: (response) => {
          this.emailSent.emit(response);
          this.close();
        },
        error: (error) => {
        },
      });
  }
  onSend() {
    this.postEmail();
  }
  onEdit() {
    this.isEdit = true;
  }
  onCancel() {
    this.isEdit = false;
    // Reset form to defaults when cancelling
    this.emailForm.patchValue({
      custom_subject: this.defaultSubject,
      custom_body: this.defaultBody
    });
  }
 
}
